document.addEventListener('DOMContentLoaded', function() {
    // Set up an interval to check for the ReCharge container
    const rechargeCheckInterval = setInterval(function() {
        const rechargeContainer = document.querySelector('.product-details-wrapper form .rc-container-wrapper');
        
        // If we found the element
        if (rechargeContainer) {
            // Remove the element from DOM
            rechargeContainer.remove();
            
            // Clear the interval since we don't need to check anymore
            clearInterval(rechargeCheckInterval);
            console.log('ReCharge container removed successfully');
        }
    }, 100); // Check every 100ms

    // Set a timeout to eventually stop checking after 10 seconds to prevent infinite checking
    setTimeout(function() {
        clearInterval(rechargeCheckInterval);
        console.log('Stopped checking for ReCharge container after timeout');
    }, 10000); // Stop checking after 10 seconds
});
